import type { QnaQuestion } from "@/lib/api/fddQa";
import { DEMO_QNA_QUESTIONS } from "./demoQnaQuestions";

export function demoQnaResponseAnswers(questions: QnaQuestion[], text: string) {
  const matches: { id: string; answer: string }[] = [];
  questions.filter((question) => question.status !== "Rejected").forEach((item) => {
    // Original pasted-text matching from the retired QuestionsList handler.
    const keywords = item.question.toLowerCase().split(' ').filter(w => w.length > 4);
    const matchCount = keywords.filter(kw => text.toLowerCase().includes(kw)).length;
    if (matchCount >= 2) {
      const sentences = text.split(/[.!?\n]+/).filter(s => s.trim());
      const relevant = sentences.filter(s => keywords.some(kw => s.toLowerCase().includes(kw)));
      if (relevant.length > 0) {
        matches.push({ id: item.id, answer: relevant.join('. ').trim() + '.' });
        return;
      }
    }

    // File upload revealed the answers already stored in the original demo register.
    const example = DEMO_QNA_QUESTIONS.find((question) => question.id === item.id);
    const answer = item.answer || example?.answer;
    if (answer) matches.push({ id: item.id, answer });
  });
  return matches;
}
